// extracted by mini-css-extract-plugin
export default {"more":"MainNavigation_more__+Knb2"};